<template>
  <div class="card">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <section class="has-text-centered pdb-40px">
        <p class="is-size-3 has-text-weight-bold">
          {{$t('addSchemaComptable.parametrageLibelle.paramEcriture.titleReference')}}
        </p>
      </section>
      <b-field
        :label="label">
        <b-input v-model="reference" ref="referenceInput"/>
      </b-field>
      <div class="columns is-multiline mgb-20px">
        <div class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer"
              @click="addText('{CODE_FACTURE}')">
            {CODE_FACTURE}
          </p>
          <p class="has-text-default">
            {{$t('addSchemaComptable.parametrageLibelle.paramEcriture.codeFacture')}}
          </p>
        </div>
        <div class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer"
              @click="addText('{CODE_BAIL}')">
            {CODE_BAIL}
          </p>
          <p class="has-text-default">
            {{$t('addSchemaComptable.parametrageLibelle.paramEcriture.codeBail')}}
          </p>
        </div>
      </div>
      <div class="buttons">
        <qd-button type="is-light"
                  class="btn-modal-annuler"
                  @click="close()">
          {{$t('addSchemaComptable.parametrageLibelle.paramEcriture.exit')}}
        </qd-button>
        <qd-button type="is-info"
                  @click="save()">
          {{$t('general.button.sauvegarder')}}
        </qd-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'p_edit_ReferenceEcriture',
  props: {
    value: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    reference: '',
  }),
  computed: {
    label() {
      return this.$t('addSchemaComptable.parametrageLibelle.' + this.type);
    },
  },
  methods: {
    addText(text) {
      this.reference += text;
    },
    close() {
      this.$emit('close');
    },
    save() {
      this.$emit('save', {
        value: this.reference,
        type: this.type,
      });
      this.close();
    },
  },
  mounted() {
    this.$refs.referenceInput.focus();
    this.reference = this.value ? this.value : '';
  },
};
</script>

<style>

</style>
